module.exports = __webpack_public_path__ + "media/images/icons/filled/interaction-59c9611aa016c5263a644fa941b85518.svg";